import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  parenthesisInNegativeValue,
  tableIndexNumber,
  totalPages,
} from "../../utils/services";
import { useDebtorList } from "../../api/get";
import { CreditorDebitorListResponse } from "../../api/types";
import ChequeListCard from "../ChequeList/ChequeListCard/ChequeListCard";
import { Table } from "../CustomReactTable/CustomReactTable";
import { NoDataPage } from "../NoDataPage/NoDataPage";
import { Loader } from "../Loader/Loader";

interface ViewAlProps {
  viewAll: boolean;
}
export const DebtorList: React.FC<ViewAlProps> = ({ viewAll }) => {
  const [queryPageIndex, setQueryPageIndex] = useState(0);
  const [queryPageSize, setQueryPageSize] = useState(() => (viewAll ? 10 : 6));

  //useQuery
  const { data: debtorList, isLoading } = useDebtorList(
    queryPageIndex,
    queryPageSize,
  );

  const FormatTable = (
    array: CreditorDebitorListResponse[],
    pageIndex: number,
    pageSize: number,
  ) => {
    if (array) {
      const formatData = array?.map(
        (item: CreditorDebitorListResponse, index) => {
          return {
            s_n: tableIndexNumber(pageIndex, pageSize, index),
            name: item?.user_info?.name || "-",
            mobile_no: item?.user_info?.mobile_no || "-",
            amount: parenthesisInNegativeValue(item?.amount),
          };
        },
      );
      return formatData;
    }
    return [];
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.N",
        accessor: "s_n",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Mobile No.",
        accessor: "mobile_no",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
    ],
    [],
  );

  return (
    <div className="dashboard-table card-height">
      {!viewAll ? (
        <>
          {isLoading ? (
            <Loader loaderType="Spinner" />
          ) : debtorList && debtorList?.data.length > 0 ? (
            <>
              {debtorList?.data
                ?.slice(0, 5)
                ?.map((item: any, index: number) => (
                  <ChequeListCard
                    name={item?.user_info?.name}
                    mobile={item?.user_info?.mobile_no}
                    amount={item?.amount}
                    logo={item?.user_info?.name?.slice(0, 1)}
                  />
                ))}

              <Link to={`/debtor-list`} className="view-btn">
                <button
                  type="button"
                  className="content light-secondary next small-button "
                >
                  View All
                </button>
              </Link>
            </>
          ) : (
            <NoDataPage description="Looks like there are no entries here yet" />
          )}
        </>
      ) : (
        <>
          <div className="head-section">
            <p className="small-title">Debtors List</p>
          </div>
          <Table
            excelDownload={true}
            loading={isLoading}
            columns={columns}
            data={
              debtorList
                ? FormatTable(debtorList.data, queryPageIndex, queryPageSize)
                : []
            }
            totalPages={
              debtorList &&
              totalPages(queryPageSize, debtorList.pagination.total_count)
            }
            totalEntries={debtorList && debtorList.pagination.total_count}
            queryPageIndex={queryPageIndex}
            setQueryPageIndex={setQueryPageIndex}
            queryPageSize={queryPageSize}
            setQueryPageSize={setQueryPageSize}
            showPageSize={true}
          />
        </>
      )}
    </div>
  );
};
